export const getTabIndexAttribute = (
  a11y: { tabIndex?: number | string; tabindex?: number | string } = {},
) => {
  const tabIndex = a11y.tabIndex ?? a11y.tabindex ?? undefined;
  return tabIndex !== undefined ? { tabIndex: Number(tabIndex) } : {};
};

type KeyCode = UnpackValueTypes<typeof keyCodes>;
export type UnpackValueTypes<T> = T extends { [key: string]: infer R }
  ? R
  : never;

function activateByKey(key: KeyCode): React.KeyboardEventHandler<HTMLElement> {
  return (event) => {
    if (event.key === key) {
      event.preventDefault();
      event.stopPropagation();
      event.currentTarget.click();
    }
  };
}

export const keyCodes = {
  enter: 'Enter',
  space: ' ',
  end: 'End',
  home: 'Home',
  escape: 'Escape',
  arrowLeft: 'ArrowLeft',
  arrowUp: 'ArrowUp',
  arrowRight: 'ArrowRight',
  arrowDown: 'ArrowDown',
  tab: 'Tab',
  delete: 'Delete',
  a: 'a',
  z: 'z',
  pageUp: 'PageUp',
  pageDown: 'PageDown',
} as const;

export const activateBySpaceButton = activateByKey(keyCodes.space);
export const activateByEnterButton = activateByKey(keyCodes.enter);
export const activateBySpaceOrEnterButton: React.KeyboardEventHandler<
  HTMLElement
> = (event) => {
  activateByEnterButton(event);
  activateBySpaceButton(event);
};
